<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛">
		<FHeader :checkId="23"></FHeader>
		<FOtherBanner :name1="'关于我们'" :name2="'About Us'"></FOtherBanner>
		<!-- <FTitle></FTitle> -->
		<article style="height: 100%;">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }" style="cursor: pointer;">首页</el-breadcrumb-item>
				<el-breadcrumb-item style="cursor: default;">关于我们</el-breadcrumb-item>
				<el-breadcrumb-item style="cursor: default;color:black">红色建设</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:50px;">
				<div style="text-align: center;">
					<div style="font-size: 26px;font-weight: 900;color: #98273A;">红色建设</div>
					<div style="padding-top: 5px;font-size: 14px;color: #98273A;">Red Construction</div>
				</div>
				<div :style="{'padding-top':'30px','height':tableList.length>6?'1100px':(tableList.length>3?'725px':'335px')}">
					<div :style="{float:'left',width:'30%','margin-right':index!=2&&index!=5&&index!=8?'calc(5% - 4px)':'0%',height:'310px','margin-top':'25px','border':'1px solid #D7D7D7'}" v-for="(item,index) in tableList" :key="index">
						<div style="color: black;font-size: 20px;padding: 50px 25px;cursor: pointer;" @click="toRedDetail(item,index)">{{item.title}}</div>
						<div style="color: #595959;font-size: 14px;margin-left: 25px;margin-right: 25px;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 4;line-height: 24px;-webkit-box-orient: vertical;margin-bottom: 20px;">{{item.description}}</div>
						<div style="font-size: 14px;border-top: 1px solid #D7D7D7;margin-right: 25px;margin-left: 25px;font-weight: 900;color: #AAAAAA;padding-top: 20px;">
							<div style="float: left;">{{item.publish.substring(0,10)}}</div>
							<img  @click="toRedDetail(item,index)" style="float: right;transform: rotate(-90deg);" src="../../assets/fImage/xiangyoujiantou.svg">
						</div>
					</div>
				</div>
				<el-pagination
					background
					layout="prev, pager, next, jumper"
					:page-size="9"
					:total="total"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeader.vue"
	import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"

	import {query} from "@/api/aboutUs";
	export default {
		name: "Index",
		components: {
			FHeader,
			FOtherBanner,
			Footer
		},
		data() {
			return {
				tableList: [],
				total:0,
				pageNo: 1,
			}
		},
		mounted() {
			this.list()
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		
		watch: {
		},
		methods: {
			async toRedDetail(item,index){
				// let up = {}
				// let next = {}
				// if(this.pageNo == 1 && index == 0){
				// 	up.title = '无'
				// 	up.id = 0
				// }else if(index == 0){
				// 	let param = {
				// 		title: '',
				// 		channelId: null,
				// 		page: (parseInt(this.pageNo)-1),
				// 		pageSize: 9,
				// 	}
				// 	await query(param).then(data => {
				// 		up = data.data.list[data.data.list.length-1]
				// 	}).catch(error => {
				// 		this.$message.error(error)
				// 	})
				// }else{
				// 	up = this.tableList[parseInt(index-1)]
				// }
				// if(index == this.tableList.length - 1){
				// 	let size = ((parseInt(this.pageNo-1))*9)+(parseInt(index) + 1)
				// 	if(size == this.total){
				// 		next.title = '无'
				// 		next.id = 0
				// 	}else{
				// 		let param = {
				// 			title: '',
				// 			channelId: null,
				// 			page: (parseInt(this.pageNo)+1),
				// 			pageSize: 9,
				// 		}
				// 		await query(param).then(data => {
				// 			next = data.data.list[0]
				// 		}).catch(error => {
				// 			this.$message.error(error)
				// 		})
				// 	}
				// }else{
				// 	next = this.tableList[parseInt(index+1)]
				// }
				// //encodeURIComponent(
				this.$router.push(
					{
						path:'/redConstructionDetail',
						query:{
							id:item.id,
							// up:JSON.stringify(up),
							// item:JSON.stringify(item),
							// next:JSON.stringify(next),
							// total:this.total,
							// pageNo:this.pageNo,
							// index:index,
							// tableLength:this.tableList.length
						}
					}
				);
			},
			handleCurrentChange(page){
				this.pageNo = page
				this.list()
			},
			list() {
				let param = {
					title: '',
					channelId: null,
					page: this.pageNo,
					pageSize: 9,
				}
				query(param).then(data => {
					this.tableList = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>
<style lang="scss" scoped="scoped">


	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
div /deep/ .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div /deep/ .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div /deep/ .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div /deep/ .el-pagination{
	text-align: center;
}
</style>
